import { debounce } from 'rxjs/operator/debounce';
import { Injectable } from '@angular/core';
import { Subject } from "rxjs/Subject";
import * as emiGlobals from 'app/globals';
import { Observable } from "rxjs/Observable";
import 'rxjs/add/operator/map';
import 'rxjs/Rx';
import 'rxjs/add/operator/concatMap';
import 'rxjs/add/operator/filter';
import 'rxjs/add/operator/catch';
import { Headers, Http, RequestOptions } from '@angular/http';

@Injectable()
export class LoanOfferGenService {

    constructor(
      private http :Http
    ) {
      this.checkHasLocalData();
      //this.doRequest();
     }
    bankOfferData=new Array();
    bankOffer;
    result;
    company_url;
    persoanlOfferUrl: string = emiGlobals.persoanlLoanUrl;
    homeOfferUrl:string = emiGlobals.homeLoanUrl;
    offerdata = new Array();
    ActualOffer;
    data;
    localLeadData: JSON;
    localCustomerInfoData: JSON;
    hasLocalLeadData: boolean = false;
    hasLocalCustomerInfoData: boolean = false;

    private headers: Headers ;
    private options: RequestOptions ;

    private generatePLComapnyOfferSource = new Subject<JSON>();
    private generateHLComapnyOfferSource =new Subject<JSON>();
    private loanFormSubmissionSource = new Subject<JSON>();
    private plQuoteGenerateSource = new Subject<JSON>();
    private hlQuoteGenerateSource = new Subject<JSON>();

    private ShowTheHlForm = new Subject<JSON>();
    private ShowThePlForm = new Subject<JSON>();

    doRequest(){
      let token =  localStorage.getItem('id_token');
      this.headers= new Headers( {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'Access-Control-Allow-Headers': 'Content-Type',
      });
      this.headers.append('Authorization','Bearer '+token);
      this.options = new RequestOptions ({ headers: this.headers} );
      console.log("doRequest",this.options);
    }

    //*** Company
    // Observable quote generation
    generatePLComapnyOffer$ = this.generatePLComapnyOfferSource.asObservable();
    // generate offer event
    generateOffer(data: JSON) {
      this.generatePLComapnyOfferSource.next(data);
    }

     //*** Company-Home Loan
    // Observable quote generation
    generateHLComapnyOffer$ = this.generateHLComapnyOfferSource.asObservable();
    // generate offer event
    generateHLOffer(data: JSON) {
      this.generateHLComapnyOfferSource.next(data);
    }

    //*** PL
    // Common Pl quote generation
    plQuoteGenerate$ = this.plQuoteGenerateSource.asObservable();
    // generate offer event
    generatePLCommonOffer(data: JSON) {
      this.plQuoteGenerateSource.next(data);
    }

    //*** HL
    // General Hl quote generation
    hlQuoteGenerate$ = this.hlQuoteGenerateSource.asObservable();
    // generate offer event
    generateHLCommonOffer(data: JSON) {
      this.hlQuoteGenerateSource.next(data);
    }

    // Observable show form on apply button click
    showHomeLoanForm$ = this.ShowTheHlForm.asObservable();
    // generate button click event
    ShowHl(data: JSON) {
      this.ShowTheHlForm.next(data);
    }
      // Observable show form on apply button click
      showPersonalLoanForm$ = this.ShowThePlForm.asObservable();
      // generate button click event
      ShowPl(data: JSON) {
        this.ShowThePlForm.next(data);
      }
  

    //*** Company Lead Submission
    // Observable lead form submission on company page
    companyPageLoanFormSubmission$ = this.loanFormSubmissionSource.asObservable();
    //Lead form submitted status update event
    loanFormSubmitted(data: JSON) {
      try {
        console.log("loanFormSubmitted",data);
        this.loanFormSubmissionSource.next(data);
      } catch (error) {
        console.log(error);
      }
    }

    // To get personal Loan Offer from API
    getPersoanlOffers(jsonData) {

      console.log(jsonData);
      try {

        this. doRequest();
        let params: URLSearchParams = new URLSearchParams();
        Object.assign(params, jsonData);
        console.log("getPersoanlOffers params",params);
        let options = new RequestOptions ({ headers: this.headers, search:params} );
        return this.http
          .get(this.persoanlOfferUrl,options)

          .map(response => response.json())

          // .filter(data => data.offers.bank_id===4) //data.Type === 5
          .catch((error:any) => Observable.throw(error || 'getPersoanlOffers error'));


      } catch (error) {
        console.log("getPersoanlOffers",error);
      }

    }

    // To get home loan offer from API
    getHomeOffers(jsonData) {
       try {
        this. doRequest();
        let params: URLSearchParams = new URLSearchParams();
        Object.assign(params, jsonData);
        console.log("getHomeOffers params",params);

        let options = new RequestOptions ({ headers: this.headers, search:params} );
          
        
        return this.http
          .get(this.homeOfferUrl,options)
        .retry(3)
        
        
          .map(response => response.json())
          .catch((error:any) => Observable.throw(error || 'getPersoanlOffers error'));

       } catch (error) {
       console.log("getHomeOffers",error);
      }

    }

    // Customer Information
    public getLocalCustomerInfoData(field){
      if(this.hasLocalCustomerInfoData){
        try {
           console.log(this.localCustomerInfoData[field],field);
           this.data=this.localCustomerInfoData[field]?this.localCustomerInfoData[field]:null;
           return this.data;
          // return (this.localCustomerInfoData[field]?this.localCustomerInfoData[field]:null);
        } catch (error) {
          console.log("Field not found",error);
        }
        return null;
      }
    }

    // Get Lead Info
    getLocalLeadContactData(field) {
      if(this.hasLocalLeadData){
        console.log(this.localLeadData[field],field);
        return (this.localLeadData[field]?this.localLeadData[field]:null);
      }
    }

    // Update customer form information with form data.
    public updateCustomerInfoData(newData){
      var localCustomerData;
      var resultData = {};
      if(localStorage.getItem('lead_customer_info')){
        localCustomerData = JSON.parse(localStorage.getItem('lead_customer_info'));
        Object.keys(localCustomerData).forEach((key) => resultData[key] = localCustomerData[key]);
      }
      Object.keys(newData).forEach((key) => resultData[key] = newData[key]);
      localStorage.setItem('lead_customer_info',JSON.stringify(resultData));
      console.log("updateCustomerInfoData -> ",resultData);
    }

    checkHasLocalData(){
      if(localStorage.getItem('lead_contact')){
        this.hasLocalLeadData = true;
        this.localLeadData = JSON.parse(localStorage.getItem('lead_contact'));
      }
      if(localStorage.getItem('lead_customer_info')){
        this.hasLocalCustomerInfoData = true;
        this.localCustomerInfoData = JSON.parse(localStorage.getItem('lead_customer_info'));
      }
    }

    //  Get Persoanl Default Offers
    getPersoanlDefaultOffers(){
      try {

        this. doRequest();
        return this.http
          .get(emiGlobals.persoanlLoanDefaultOfferUrl+'?domain=2',this.options)
          //.retry(3)
          .map(response => response.json())
          .catch((error:any) => Observable.throw(
            console.log(error),
           // error.json().error || 'getPersoanlDefaultOffers error'
          ));

      } catch (error) {
        console.log("getPersoanlDefaultOffers",error);
      }
    }

    //  Get Home Loan Default Offers
    getHomeDefaultOffers(){
      try {

        this. doRequest();
        return this.http
          .get(emiGlobals.homeLoanDefaultOfferUrl,this.options)
          //.retry(3)
          .map(response => response.json())
          .catch((error:any) => Observable.throw(
            console.log(error),
           // error.json().error || 'getPersoanlDefaultOffers error'
          ));

      } catch (error) {
        console.log("getHomeDefaultOffers",error);
      }
    }


    // Search Commpany name mapping
    searchBankComanyName(term):Observable<BankCompanyResult[]>{
      let url = emiGlobals.persoanlCompaniesList+`?q=${term}`;
      return this.http
               .get(url)
               .map(response => response.json() as BankCompanyResult[]);
    }

    searchHomeBankComanyName(term):Observable<BankCompanyResult[]>{
      return this.http
               .get(`https://ehomeloan.co.in/emi/gethlcompanylist.php?q=${term}`)
               .map(response => response.json() as BankCompanyResult[]);
    }
    getCityList(){
      if(localStorage.getItem('PortalCity')){
        return  JSON.parse(localStorage.getItem('PortalCity'));
      }else{
        return [];
      }
    }
    getBankList(){
      if(localStorage.getItem('PortalBank')){
        return  JSON.parse(localStorage.getItem('PortalBank'));
      }else{
        return [];
      }
    }

    getFilteredPersonalBanks(data){
      if(this.offerdata){
        this.offerdata.length=0;
     }
      let filter_bank_id=JSON.parse(localStorage.getItem('PortalBank_Filter_personal'));
    if(filter_bank_id.length==0){
      this.offerdata=data.offers;
      return this.offerdata;
    }else{

      if(data.offers){
        for(let j=0;j<data.offers.length;j++){
            for(let i=0;i<filter_bank_id.length;i++){
               if(data.offers[i]){
                 let bank=filter_bank_id[i];
                   if(bank){
                     if(bank==data.offers[j].id){
                       this.ActualOffer=data.offers[j];
                       this.offerdata.push(this.ActualOffer);
                     }
                   }
               }else{
                console.log("no data");
               }
           }
        }
      console.log(this.offerdata);
      return this.offerdata;

      }

    }


    }
    getCompanyNameByUrl(company_id){
       this.company_url= emiGlobals.personalCompanyListByUrl+'?q='+company_id;
      console.log( this.company_url);
      return this.http.get( this.company_url)
      .map(response => {
          return response.json();
            // console.log(response.json());
       });
      // .subscribe(response => {
      //   this.result= response;
      //   return this.result;
      //   })
    }
    getFilteredHomeBanks(data){
    
      let filter_bank_id=JSON.parse(localStorage.getItem('PortalBank_Filter_home'));

        if(this.offerdata){
           this.offerdata.length=0;
        }
        if(filter_bank_id.length==0){
          this.offerdata=data.offers;
          return this.offerdata;
        }else{
          if(data.offers){
            
            for(let j=0;j<data.offers.length;j++){
                for(let i=0;i<filter_bank_id.length;i++){
                   if(data.offers[i]){
                     let bank=filter_bank_id[i];
                       if(bank){
                         if(bank==data.offers[j].id){
                           this.ActualOffer=data.offers[j];
                           this.offerdata.push(this.ActualOffer);
                         }
                       }
                   }else{
                    console.log("no data");
                   }
               }
            }
          console.log(this.offerdata);
          return this.offerdata;

          }

        }

    }
    //bank-specific page-filtering-home
    getBankSpecificHomeOffers(data){
      
      if(this.bankOfferData){
        this.bankOfferData.length=0;
      }
      let Bank_specific_id=JSON.parse(localStorage.getItem('bank_data'));
      let bank_id=Bank_specific_id.emi1_id;
      if(data.offers){
        for(let i=0;i<data.offers.length;i++){
          if(data.offers[i]){
            if(data.offers[i].id==bank_id){
              this.bankOffer=data.offers[i];
              this.bankOfferData.push(this.bankOffer);
            }
          }else{
            console.log("no data");
          }
        }
      }
     return this.bankOfferData;
      
    } 
     //bank-specific page-filtering-personal
     getBankSpecificPersonalOffers(data){
      
      if(this.bankOfferData){
        this.bankOfferData.length=0;
      }
      let Bank_specific_id=JSON.parse(localStorage.getItem('bank_data'));
      let bank_id=Bank_specific_id.emi1_id;
      if(data.offers){
        for(let i=0;i<data.offers.length;i++){
          if(data.offers[i]){
            if(data.offers[i].bank_id==bank_id){
              this.bankOffer=data.offers[i];
              this.bankOfferData.push(this.bankOffer);
            }
          }else{
            console.log("no data");
          }
        }
      }
     return this.bankOfferData;
      
    } 

    bankDetails(){
      this.doRequest();
      let url=emiGlobals.bankdetails;
   
      return this.http
      .get(url,this.options)
       .map((response)=>{
         var res=response.json();
          if(res){
            return res;
          }
       });
    }
    bankDetailsPersonalLoan(){
      this.doRequest();
      let url=emiGlobals.bankdetailsPersonalLoan;
   
      return this.http
      .get(url,this.options)
       .map((response)=>{
         var res=response.json();
          if(res){
            return res;
          }
       });
    }

}

export class BankCompanyResult {
    name: string;
    id: string;
}


// WEBPACK FOOTER //
// ./src/app/loan/services/loan-offer-gen.service.ts